import mainTheme from '@/themes/main-theme'
import lightTheme from '@/themes/light-theme'

const getDefaultState = () => {
  return {
    name: 'main',
    values: mainTheme
  }
}

const state = getDefaultState()

const actions = {
  resetState (context) {
    context.commit('resetState')
  }
}

const mutations = {
  switchTheme (state) {
    if (state.name === 'main') {
      state.name = 'light'
      state.values = lightTheme
    } else {
      state.name = 'main'
      state.values = mainTheme
    }
  },

  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default () => ({
  namespaced: true,
  state,
  actions,
  mutations
})
